import { CSSProperties } from 'react';
import styles from 'styles/components/common/layout/Layout.module.scss';
import Nav from '../nav/Nav';
import classNames from 'classnames';
import SubNav from '../nav/SubNav';
import Footer from './Footer';

type TProps = {
  children: React.ReactNode;
  layoutStyle?: CSSProperties;
  bgColor?: boolean;
  subNav?: boolean;
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  hideFooter?: boolean;
  mode?: string;
};

const Layout = ({
  children,
  layoutStyle,
  bgColor,
  subNav,
  setIsModalOpen,
  hideFooter,
  mode,
}: TProps) => {
  return (
    <>
      <section className={styles.container}>
        <div
          className={classNames('relative', {
            [styles.bg_color]: bgColor,
          })}
        >
          <Nav />
          {subNav && setIsModalOpen && (
            <SubNav setIsModalOpen={setIsModalOpen} mode={mode} />
          )}
          <div className={classNames(bgColor ? [styles.bg_color] : 'grow_1')}>
            <div className={styles.layout} style={layoutStyle}>
              {children}
            </div>
          </div>
        </div>
      </section>
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;
